<main class="content-main">
  <linqerp-loading></linqerp-loading>
  @if (!(isLoading$ | async)) {
    <app-frames [hidden]="(isFrames$ | async) === false"></app-frames>
  }
</main>
